// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3iwJV","filesListContainer":"PosDisputesFiles_filesListContainer__2rHXP","filesButton":"PosDisputesFiles_filesButton__3sQ_w"};